module.exports = __webpack_public_path__ + "img/lamy-crm-warranty.f5153efd.png";